import { BadgeCheck, Scale, Store, ThumbsUp } from "lucide-react";
import { CartItem, PriceComponent } from "../../cart/types/cart";
import { ErrorCode } from "modules/main/types/error";
import { ProductDecision } from "./productDecission";

interface StoreResume {
  id: number;
  cost: number;
  delivery: number;
  sub_total: number;
  sub_total_theoretical: number;
  theoretical_delivery: number;
  free_delivery: boolean;
  met_conditions: boolean;
  order_complete: boolean;
  min_free_delivery: number;
  min_purchase: number;
}

export type modeOpt =
  | "SAVINGS"
  | "BALANCED"
  | "CONVENIENCE"
  | "UNIQUE_STORE"
  | "COMPLETED";

export const modeOptConfig = {
  SAVINGS: {
    value: "SAVINGS" as const,
    label: "Ahorros",
    description: "Maximiza el ahorro, aunque requiera más tiendas",
    icon: <BadgeCheck className="w-6 h-6 best-price" />,
  },
  BALANCED: {
    value: "BALANCED" as const,
    label: "Equilibrado",
    description: "Balancea ahorro y conveniencia",
    icon: <Scale className="w-6 h-6 best-price" />,
  },
  CONVENIENCE: {
    value: "CONVENIENCE" as const,
    label: "Conveniencia",
    description: "Minimiza el número de tiendas",
    icon: <ThumbsUp className="w-6 h-6 best-price" />,
  },
  UNIQUE_STORE: {
    value: "UNIQUE_STORE" as const,
    label: "En una sola tienda",
    description: "Comprar todo en una sola tienda",
    icon: <Store className="w-6 h-6 text-destructive" />,
  },
} as const;

export interface StoreTotals {
  store_id: number;
  sub_total: number;
  delivery: number;
  products: number;
  messages: string;
}

export interface OptimizedScenario {
  alert: boolean;
  scenarioType: modeOpt;
  reccomended: boolean;
  order_id: number;
  number_stores: number;
  order_group_id: number;
  reason: string | null;
  total_saved: number;
  total_cost: number;
  total_delivery: number;
  // total_saving:number,
  stores_used: number;
  store_resume: StoreResume[];
  opt_cart: CartItem[];
  workAreaCart?: CartItem[];

  total_per_store_jsons: StoreTotals[];
}

interface OptimizedCartSentResponse {
  order_id: number;
  message: string;
}

interface OptimizedCartStatusResponse {
  status: "AC" | "CO" | "CN" | "PR";
  error?: string;
}

interface OptimizedCartResponse {
  scenarios: OptimizedScenario[];
  error: ErrorCode;
}

interface OptimizedCartRequest {
  products: CartItem[];
  preferred_stores?: number[];
  user_decisions?: ProductDecision[];
}

export const emptyScenario: OptimizedScenario = {
  alert: false,
  scenarioType: "SAVINGS",
  reccomended: false,
  total_cost: 0,
  total_delivery: 0,
  // total_saving: 0,
  number_stores:0,
  stores_used: 0,
  order_id: 0,
  order_group_id: 0,
  store_resume: [],
  opt_cart: [],
  total_per_store_jsons: [],
  total_saved: 0,
  reason: null,
};

interface PriceComponentStatus extends PriceComponent {
  checked: boolean;
}

interface CartItemStatus extends CartItem {
  price_component: Array<PriceComponentStatus>;
}

interface CartCreationStatus {
  store_id: number;
  products: CartItemStatus[];
}

export interface StoreSessionStatus {
  store_id: number;
  connected: boolean;
}

export interface ScenarioStoreSessionsResponse {
  scenario_id: number;
  stores: StoreSessionStatus[];
}

export type {
  OptimizedCartResponse,
  OptimizedCartRequest,
  StoreResume,
  OptimizedCartSentResponse,
  OptimizedCartStatusResponse,
  CartCreationStatus,
  CartItemStatus,
};
